import type { ButtonHTMLAttributes } from 'react';

export interface SwitchProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'className' | 'onChange'> {
  readonly checked: boolean;
  readonly onChange: (next: boolean) => void;
  readonly className?: string;
  readonly label?: string;
}

export function Switch({ checked, onChange, className, label, disabled, ...rest }: SwitchProps): JSX.Element {
  const cls = ['switch', checked ? 'on' : '', className ?? ''].filter(Boolean).join(' ');
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={label}
      disabled={disabled}
      className={cls}
      onClick={() => !disabled && onChange(!checked)}
      {...rest}
    />
  );
}
